<template>
  <v-navigation-drawer
    app
    clipped
    permanent
  >
    <v-list nav>
      <v-list-item
        v-if="showBack"
        prepend-icon="mdi-arrow-left"
        @click="goDeposits"
      >
        <v-list-item-title>{{ $route.query.admin_user ? 'All user deposits' : 'Your deposits' }}</v-list-item-title>
      </v-list-item>

      <v-divider
        v-if="showBack && deposits.length > 0"
        class="my-2"
      />

      <v-list-item
        v-for="(deposit, index) in deposits"
        :key="index"
        :disabled="deposit.status !== 'open'"
        :prepend-icon="deposit.status === 'open' ? 'mdi-folder' : 'mdi-folder-lock'"
        @click="goDeposit(deposit)"
      >
        <v-list-item-title>{{ deposit.name }}</v-list-item-title>
      </v-list-item>
    </v-list>

    <template #append>
      <v-list nav>
        <v-divider class="mb-2" />
        <v-list-item @click="signOut">
          <template #prepend>
            <v-icon size="32">
              mdi-logout
            </v-icon>
          </template>
          <v-list-item-title>Sign out</v-list-item-title>
        </v-list-item>
      </v-list>
    </template>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'DepositsSidebar',
  props: {
    deposits: { type: Array, default: () => [] },
    showBack: { type: Boolean, default: false },
  },
  methods: {
    goDeposit(deposit) {
      this.$router.push({
        name: 'DepositFileHome',
        params: { deposit_id: deposit.id },
        query: {
          depositor: deposit.depositor['custom:identityid'],
          deposit_name: deposit.name,
          created_date: deposit.createdDate || '',
        },
      })
    },
    goDeposits() {
      const adminUser = this.$route.query.admin_user
      if (adminUser) {
        const q = { restore_user: adminUser }
        if (this.$route.query.admin_user_name) q.admin_user_name = this.$route.query.admin_user_name
        if (this.$route.query.admin_search) q.admin_search = this.$route.query.admin_search
        if (this.$route.query.admin_page) q.admin_page = this.$route.query.admin_page
        this.$router.push({ path: '/admin', query: q })
      } else {
        this.$router.push({ name: 'DepositHome' })
      }
    },
    signOut() {
      // call Cognito + navigate; bypass the route guard indirection
      this.$cognitoAuth.signOut()
      this.$router.push({ name: 'SignIn' })
    },
  },
}
</script>
